import { useState } from "react"

const useAnimatedWindow = () => {
  const [openedWindows, setOpenedWindows] = useState([])

  return { openedWindows, setOpenedWindows }
}

export default useAnimatedWindow
